
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
@Component({ name: 'vButton' })
export default class indexView extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  label!: string
  @Prop({
    type: Boolean,
    default: false,
  })
  diabled!: boolean
  @Prop({
    type: Number,
    default: 2.1,
  })
  width!: number

  @Watch('diabled', { deep: true })
  handleDisabled() {
    //
  }
  mounted() {
    this.$nextTick(() => {
      const khEl: any = this.$refs.khButton
      khEl?.querySelector('.van-button--default')?.setAttribute('style', `width:${this.width}rem`)
    })
  }
  clickButton() {
    this.$emit('clickButton')
  }
}
